import { gql } from '@apollo/client'

export const PROJECTS_QUERY = gql`
  query projects($sortBy: ProjectSort, $filter: ProjectFilter, $page: Int, $limit: Int) {
    projects(sortBy: $sortBy, filter: $filter, page: $page, limit: $limit) {
      collection {
        id
        title
        insuranceId
        interface
        archived
        collisionDetectionEnabled
        clientPayment
        policyNumberRegex
        policyNumberMask
        claimNumberRegex
        claimNumberMask
        additionalIncomeBillable
        withLeadingClaimNumber
        legalAdviceActualProcessingTypeId
        serviceCallActualProcessingTypeId
        jumpOffActualProcessingTypeId
        directForwardActualProcessingTypeId
        incomingCallServiceCallEnabled
        incomingCallJumpOffEnabled
        incomingCallDirectForwardEnabled
        setActualProcessingTypeInFirstContact
      }
      metadata {
        totalCount
      }
    }
  }
`
